<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>拉新配置列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!--添加 -->
        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="OpenBianji()">添加</el-button>
            </el-form-item>
        </el-form>

        <!-- 列表 -->
        <el-table size="small" :data="DataList" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;margin-top: 24px;">
            <el-table-column align="center" sortable type="index" label="序号"></el-table-column>
            <el-table-column align="center" sortable prop="priceOne" label="一级奖励奖学金" width="150"></el-table-column>
            <el-table-column align="center" sortable prop="priceTwo" label="二级奖励奖学金" width="150"></el-table-column>
            <el-table-column align="center" sortable label="创建时间" width="150">
                <template slot-scope="scope">
                    <div>{{ transformDate(scope.row.createTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" show-overflow-tooltip width="150px">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="OpenBianji(scope.row)">修改</el-button>
                    <el-button size="mini" type="danger" @click="deleData(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 编辑界面 -->
        <el-dialog :title="tit" :visible.sync="editFormVisiible" width="30%">
            <el-form label-width="120px">
                <el-form-item label="一级奖励奖学金">
                    <el-input size="small" v-model="xiugai.priceOne" auto-complete="off"
                        placeholder="请输入一级奖励奖学金"></el-input>
                </el-form-item>
                <el-form-item label="二级奖励奖学金">
                    <el-input size="small" v-model="xiugai.priceTwo" auto-complete="off"
                        placeholder="请输入二级奖励奖学金"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog()'>取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="addData()"
                    v-if="tit == '添加'">添加</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="upData()"
                    v-if="tit == '修改'">修改</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    getPullNewList,
    addPullNew,
    deletePullNew,
    upPullNew
} from "../../api/userMG";
export default {
    data() {
        return {
            DataList: [],
            loading: false,
            tit: '添加',
            editFormVisiible: false,
            xiugai: {
                id: '',
                priceOne: '',
                priceTwo: '',
                createTime: '',
            }
        }
    },
    created() {
        this.getdata()
    },
    methods: {
        // 修改
        upData() {
            this.loading = true,
                upPullNew(this.xiugai).then((res) => {
                    this.loading = false;
                    if (res.code == 200) {
                        this.editFormVisiible = false
                        this.$message.success(res.msg)
                        this.getdata(1)
                    } else {
                        this.editFormVisiible = false
                        this.$message.error(res.msg);
                    }
                })
        },
        // 添加
        addData() {
            this.loading = true,
                addPullNew(this.xiugai).then((res) => {
                    this.loading = false;
                    if (res.code == 200) {
                        this.editFormVisiible = false
                        this.$message.success(res.msg)
                        this.getdata(1)
                    } else {
                        this.editFormVisiible = false
                        this.$message.error(res.msg);
                    }
                })
        },
        // 打开编辑器
        OpenBianji(row) {
            this.editFormVisiible = true;
            if (row != undefined && row != "undefined") {
                this.tit = "修改";
                this.xiugai.id = row.id;
                this.xiugai.priceOne = row.priceOne;
                this.xiugai.priceTwo = row.priceTwo;
                this.xiugai.createTime = row.createTime;
            } else {
                this.tit = "添加";
                this.xiugai.id = '';
                this.xiugai.priceOne = '';
                this.xiugai.priceTwo = '';
                this.xiugai.createTime = '';
            }
        },
        // 关闭编辑对话框
        closeDialog() {
            this.editFormVisiible = false
            this.$message({
                type: 'info',
                message: '已取消编辑'
            })
        },
        // 删除
        deleData(row) {
            this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                let data = {
                    id: row.id
                }
                deletePullNew(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.getdata(1)
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 获取数据
        getdata() {
            this.loading = true;
            getPullNewList().then((res) => {
                this.loading = false;
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg,
                    });
                } else {
                    this.DataList = [];
                    this.DataList.push(res.data.data);
                    return;
                }
            })
        },
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/laxin/Laxin.vue